import { remCSS } from '@gimlite/common';
import classNames from 'classnames';
import React, { memo } from 'react';
import './row.component.scss';

export declare namespace RowType {
  type Props = {
    className?: string | null;
    children?: React.ReactNode | null;
    justifyContent?: 'flex-start' | 'center' | 'flex-end' | 'space-between';
    alignItems?: 'flex-start' | 'center' | 'flex-end';
    gap?: number;
    width?: 'max-content' | 'min-content';
    flexWrap?: 'wrap' | 'nowrap';
    columnExtend?: number;
    padding?: {
      top?: string;
      right?: string;
      bottom?: string;
      left?: string;
    };
  };
}

export const Row = memo(
  ({
    children,
    className,
    justifyContent = 'flex-start',
    alignItems = 'flex-start',
    gap = 10,
    width = 'min-content',
    flexWrap = 'nowrap',
    padding,
    columnExtend = 1,
  }: RowType.Props) => {
    return (
      <div
        style={{
          justifyContent,
          alignItems,
          gap: `${remCSS(gap)}`,
          width: width === 'max-content' ? '100%' : 'min-content',
          flexWrap,
          paddingBottom: padding?.bottom,
          paddingRight: padding?.right,
          paddingTop: padding?.top,
          paddingLeft: padding?.left,
          gridColumn: `span ${columnExtend}`,
        }}
        className={classNames('row', className)}
      >
        {children}
      </div>
    );
  },
);
